import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SettingsIcon from "@mui/icons-material/Settings";
import AddIcon from "@mui/icons-material/Add";
import SFGBoxTable from "./SFGBoxTable";
import {
  Box,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  createSFGBoxAndHistory,
  getSFGBagDetails,
  getSFGBoxNo,
  printAgainSFGBoxLabel,
} from "./services";
import Button from "../../components/Button/Button";
import { images } from "../../config/images";
import QRCode from "qrcode.react";
import { getClasses, getSizes } from "../AddBatch/services";
import {
  getcuff,
  getLotNumber,
  getOrderIdParring,
  getPairingGlovesType,
  getParingLength,
} from "../GlovesPairing/services";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";

const SFGPrinter = () => {
  const popupRef = useRef(null);
  const [printPreviewStatus, setPrintPreviewStatus] = useState(false);
  const [printHistoryStatus, setPrintHistoryStatus] = useState(false);
  const [addStatus, setAddStatus] = useState(false);
  const [settingStatus, setSettingStatus] = useState(false);
  const [boxNo, setBoxNo] = useState();
  const [Uid, setUid] = useState("");
  const [newUidCheck, setNewUidCheck] = useState(null);
  const initialState = { ls_fuid_match: false };
  const [appState, setAppState] = useState(initialState);
  const [dispatchOrder, setDispatchOrder] = useState([]);
  const [orderIdPopUp, setOrderIdPopUp] = useState(false);
  const [wrongOrderIdPopUp, setWrongOrderIdPopUp] = useState(false);
  const [wrongIdMessage, setWrongIdMessage] = useState("");
  const [orderIdButton, setOrderIdButton] = useState([]);
  const [printOrderStatus, setPrintOrderStatus] = useState(true);
  const [productDescription1, setProductDescription1] = useState("");
  const [productDescription2, setProductDescription2] = useState("");
  const [productDescription3, setProductDescription3] = useState("");
  const [qty1, setQty1] = useState("");
  const [qty2, setQty2] = useState("");
  const [qty3, setQty3] = useState("");
  const [printerChecked1, setPrinterChecked1] = useState(false);
  const [printerChecked2, setPrinterChecked2] = useState(false);
  const [printerChecked3, setPrinterChecked3] = useState(true);
  const [apicount, setApiCount] = useState(false);
  const [printdisable, setPrintdisable] = useState(false);
  const [isPrinting, setisPrinting] = useState(false);
  const [isPrintingDone, setisPrintingDone] = useState(false);
  const [printAgainStatus, setPrintAgainstatus] = useState(false);
  const [boxID, setboxID] = useState("");
  const [noDataStatus, setNoDataStatus] = useState(false);
  const [nullDataPopup, setNullDataPopup] = useState(false);
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectClass] = useState("");
  const [size, setSize] = useState([]);
  const [selectSize, setSelectSize] = useState("");
  // State to manage the dialog box
  const [openDialog, setOpenDialog] = useState(true);
  const [glovesType, setGlovesType] = useState([]);
  const [selectGlovesType, setSelectGlovesType] = useState("");
  const [GlovesLength, setGlovesLength] = useState([]);
  const [selectGlovesLength, setSelectGlovesLength] = useState("");
  const [cuff, setCuff] = useState([]);
  const [selectCuff, setSelectCuff] = useState("");
  const [quantity, setQuantity] = useState("");
  const [sfgLabel, setSfgLabel] = useState("");
  // New state variables for validation
  const [firstScannedClass, setFirstScannedClass] = useState(null);
  const [expectedGlovesLength, setExpectedGlovesLength] = useState(null);
  const [maxQuantity, setMaxQuantity] = useState(null);
  const [isWrongClass, setIsWrongClass] = useState(false);
  const [isWrongLength, setIsWrongLength] = useState(false);
  const [lotNumber, setLotNumber] = useState("");
  const [isOverQuantity, setIsOverQuantity] = useState(false);
  const [orderItem, setOrderItem] = useState("");

  const { login } = useSelector((state) => state.batchState);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log("Form submitted!");
  };

  const modalStyle = {
    position: "absolute",
    top: "56%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%", // Use a percentage for responsive width
    maxWidth: 500, // Set a maximum width for larger screens
    bgcolor: "background.paper",
    borderRadius: "8px",
    boxShadow: 24,
    p: 0,
    overflowY: "auto", // Enable vertical scrolling for long content
    maxHeight: "85vh", // Set a maximum height to prevent content from overflowing
  };

  const headerStyle = {
    bgcolor: "#192d6e",
    color: "white",
    p: 2,
    textAlign: "center",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    position: "relative",
  };

  const inputStyle = {
    width: "100%",
    border: "1px solid #ccc",
    borderRadius: "4px",
    padding: "8px",
    boxSizing: "border-box", // Ensure padding and border are included in the element's total width and height
    marginTop: "-2px",
  };

  const labelStyle = {
    display: "block", // Make labels block-level elements for better stacking
    textAlign: "left",
    marginBottom: "4px",
    fontWeight: "500",
  };

  useEffect(() => {
    getData();
    return () => {};
  }, []);
  const getData = async () => {
    try {
      const resp = await getClasses();
      setClasses(resp.data.payload);
      const resp3 = await getSizes();
      setSize(resp3.data.payload);
      const resp4 = await getcuff();
      setCuff(resp4.data);
      // Call the getPairingGlovesType API endpoint and set the glovesType state
      const resp1 = await getPairingGlovesType();
      setGlovesType(resp1.data);
      // Call the getParingLength API endpoint and set the glovesLength state
      const resp2 = await getParingLength();
      setGlovesLength(resp2.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (newUidCheck !== null) {
      dispatchOrderDetailAPI();
    }
  }, [newUidCheck]);
  const uidType1 = Uid;
  const uidValidation = uidType1
    ? uidType1.split("/").pop() == "raychem."
      ? ""
      : uidType1.split("/").pop()
    : "";

  const scanUidType = uidValidation.length <= 8 ? uidValidation : "";
  useEffect(() => {
    if (scanUidType.length == 8) {
      setNewUidCheck(newUidCheck + 1);
    }
  }, [scanUidType]);

  const ClosePopUp = () => {
    setOrderIdPopUp(false);
    setWrongOrderIdPopUp(false);
  };
  const NoPrintHandle = () => {
    setisPrintingDone(false);
    setPrintAgainstatus(true);
  };
  useEffect(() => {
    if (scanUidType.length == 8) {
      setApiCount(!apicount);
      setNewUidCheck(newUidCheck + 1);
    }
  }, [scanUidType]);

  useEffect(() => {
    if (printPreviewStatus) {
      GetLocalData();
    }
  }, [printPreviewStatus]);

  useEffect(() => {
    RefreshDispatchOrder();
    handleBoxNumber();
    GetLocalData();
    GetPrinterData();
  }, [apicount]);

  const GetPrinterData = () => {
    if (localStorage.getItem("B_Lable_Printer")) {
      const Printers = JSON.parse(
        localStorage.getItem("B_Lable_Printer")
      ).Printer;
      if (Printers == 1) {
        setPrinterChecked1(true);
        setPrinterChecked2(false);
        setPrinterChecked3(false);
      }
      if (Printers == 2) {
        setPrinterChecked1(false);
        setPrinterChecked2(true);
        setPrinterChecked3(false);
      }
      if (Printers == 3) {
        setPrinterChecked1(false);
        setPrinterChecked2(false);
        setPrinterChecked3(true);
      }
      console.log("Printers", Printers);
    }
  };

  const GetLocalData = () => {
    try {
      const localDispatchOrderDetail = JSON.parse(
        localStorage.getItem("SFGOrderDetailTable")
      );

      const localOrderIDList = JSON.parse(localStorage.getItem("OrderIDList"));
      setOrderIdButton(localOrderIDList);
      RefreshDispatchOrder();

      if (localOrderIDList.length === 1) {
        console.log("Flow Go On .......length 1");
        const filteredData1 = localDispatchOrderDetail.filter(
          (item) => item.order_id == localOrderIDList[0]
        );
        setProductDescription1(filteredData1[0].product_description);
        setQty1(filteredData1.length);
      }

      if (localOrderIDList.length === 2) {
        console.log("Flow Go On .......length 2");
        const filteredData1 = localDispatchOrderDetail.filter(
          (item) => item.order_id == localOrderIDList[0]
        );
        const filteredData2 = localDispatchOrderDetail.filter(
          (item) => item.order_id == localOrderIDList[1]
        );
        setProductDescription1(filteredData1[0].product_description);
        setQty1(filteredData1.length);
        setProductDescription2(filteredData2[0].product_description);
        setQty2(filteredData2.length);
      }
      if (localOrderIDList.length === 3) {
        console.log("Flow Go On .......length 3");
        const filteredData1 = localDispatchOrderDetail.filter(
          (item) => item.order_id == localOrderIDList[0]
        );
        const filteredData2 = localDispatchOrderDetail.filter(
          (item) => item.order_id == localOrderIDList[1]
        );
        const filteredData3 = localDispatchOrderDetail.filter(
          (item) => item.order_id == localOrderIDList[2]
        );
        setProductDescription1(filteredData1[0].product_description);
        console.log("filteredData1", filteredData1);
        console.log("typeof(filteredData1)", typeof filteredData1);

        setQty1(filteredData1.length);
        setProductDescription2(filteredData2[0].product_description);
        setQty2(filteredData2.length);
        setProductDescription3(filteredData3[0].product_description);
        setQty3(filteredData3.length);
      }
    } catch (e) {
      console.log("error from GetLocalData", e);
    }
  };
  const RefreshDispatchOrder = () => {
    const getlocaldata = localStorage.getItem("SFGOrderDetailTable");

    const getlocaldata2 = JSON.parse(getlocaldata);
    setDispatchOrder(getlocaldata2);
    const localOrderIDList = JSON.parse(localStorage.getItem("OrderIDList"));
    setOrderIdButton(localOrderIDList);
  };
  const handlePrintagain = async () => {
    PrintAgainBoxLabelAPI();
  };
  useEffect(() => {
    if (selectGlovesType && selectedClass) {
      getLotNumberData();
    }
  }, [selectGlovesType, selectedClass]);
  const getLotNumberData = async () => {
    const params = {
      gloves_type: selectGlovesType,
      class_name: selectedClass,
    };
    try {
      // Call the API to get the lot number for the selected gloves type and left class
      const resp = await getLotNumber(params);
      if (resp.status == 200 || resp.status == 201) {
        // If the API call is successful, set the lot number in the state
        setLotNumber(resp.data.payload);
      }
    } catch (error) {
      console.log("handleSubmit", error);
    }
  };
  const PrintAgainBoxLabelAPI = async () => {
    setisPrinting(true);
    setPrintAgainstatus(false);

    const parms = {
      sfg_box_id: boxID,
      printer: printerChecked3
        ? "Printer 3"
        : null ?? printerChecked2
        ? "Printer 2"
        : null ?? printerChecked1
        ? "Printer 1"
        : null,
    };
    try {
      const PrintBox = await printAgainSFGBoxLabel(parms);
      setisPrinting(false);
      setisPrintingDone(true);

      if (PrintBox.status === 200 || PrintBox.status === 201) {
        RefreshDispatchOrder();
        GetLocalData();
      }
    } catch (e) {
      setisPrinting(false);
    }
  };

  const handleRemoveStorage = async () => {
    localStorage.removeItem("OrderIDList");
    localStorage.removeItem("SFGOrderDetailTable");
    localStorage.removeItem("Customer_Name");
    localStorage.removeItem("firstScannedClassData");
    localStorage.removeItem("firstScannedClass"); // Clear validation data
    localStorage.removeItem("maxQuantity"); // Clear validation data
    localStorage.removeItem("expectedGlovesLength"); // Clear validation data
    setisPrintingDone(false);
    setFirstScannedClass(null); // Reset validation state
    setMaxQuantity(null);
    setExpectedGlovesLength(null);
  };

  const getValidationData = (gloveClass) => {
    const gloveData = {
      "00": { quantity: 120, length: ["360"] },
      0: { quantity: 60, length: ["360", "410"] },
      1: { quantity: 50, length: ["360", "410"] },
      2: { quantity: 30, length: ["360", "410"] },
      3: { quantity: 20, length: ["360", "410"] },
      4: { quantity: 20, length: ["410"] },
    };
    return gloveData[gloveClass];
  };
  // At the top of your component, after other state variables

  useEffect(() => {
    const storedClass = localStorage.getItem("firstScannedClass");
    if (storedClass) {
      setFirstScannedClass(storedClass);
      // Also retrieve and set other validation data
      setMaxQuantity(JSON.parse(localStorage.getItem("maxQuantity")));
      setExpectedGlovesLength(
        JSON.parse(localStorage.getItem("expectedGlovesLength"))
      );
    }
  }, []);
  const dispatchOrderDetailAPI = async () => {
    const params = {
      uid: scanUidType,
    };

    console.log("params", params);
    const isFirstUidExists = (getlocaldata2, DispatchOrderDetail) => {
      getlocaldata2.some((item) => {
        if (item.first_uid === DispatchOrderDetail.data.payload.first_uid) {
        }
      });
      return getlocaldata2.some(
        (item) => item.first_uid === DispatchOrderDetail.data.payload.first_uid
      );
    };

    try {
      const DispatchOrderDetail = await getSFGBagDetails(params);

      if (DispatchOrderDetail.status === 200) {
        const newGloveData = DispatchOrderDetail.data.payload;
        const newGloveClass = newGloveData.class;
        const newGloveProductDescription = newGloveData.product_description;

        let newGloveLength = newGloveData.length;
        if (!newGloveLength && newGloveProductDescription) {
          if (newGloveProductDescription.includes("360")) {
            newGloveLength = "360";
          } else if (newGloveProductDescription.includes("410")) {
            newGloveLength = "410";
          } else if (
            newGloveProductDescription.includes("360") &&
            newGloveProductDescription.includes("410")
          ) {
            // Handle cases where both lengths might be present if needed, though unlikely.
            // You might need to refine this logic based on your specific product descriptions.
          }
        }

        const validationData = getValidationData(newGloveClass);

        if (!validationData) {
          setWrongIdMessage("Invalid class for glove.");
          setWrongOrderIdPopUp(true);
          setUid("");
          return;
        }

        // Inside the `dispatchOrderDetailAPI` function

        if (firstScannedClass == null) {
          // This is the first glove being scanned.
          setFirstScannedClass(newGloveClass);
          // Persist the first scanned class to localStorage
          localStorage.setItem("firstScannedClass", newGloveClass);
          setMaxQuantity(validationData.quantity);
          setExpectedGlovesLength(validationData.length);
          localStorage.setItem("maxQuantity", validationData.quantity);
          localStorage.setItem(
            "expectedGlovesLength",
            JSON.stringify(validationData.length)
          );
        } else {
          console.log(
            "newGloveClassnewGloveClass",
            newGloveClass,
            localStorage.getItem("firstScannedClassData")
          );

          // Check if the new glove's class matches the first scanned class
          if (newGloveClass !== localStorage.getItem("firstScannedClassData")) {
            setIsWrongClass(true); // Show toaster for wrong class
            setAddStatus(false);
            setUid("");
            return;
          }

          // Check if the new glove's length is valid for its class
          if (!validationData.length.includes(newGloveLength)) {
            setIsWrongLength(true); // Show toaster for wrong length
            setAddStatus(false);
            setUid("");
            return;
          }

          // Check if the quantity limit has been reached
          const currentQuantity =
            JSON.parse(localStorage.getItem("SFGOrderDetailTable"))?.length ||
            0;
          if (currentQuantity >= maxQuantity) {
            setIsOverQuantity(true); // Show toaster for over quantity
            setAddStatus(false);
            setUid("");
            return;
          }
        }

        setUid("");

        const DispatchOrderList = () => {
          const getlocaldata = localStorage.getItem("SFGOrderDetailTable");
          const getlocaldata2 = JSON.parse(getlocaldata);

          const olddata = [getlocaldata2];

          const uidToCheck = DispatchOrderDetail.data.payload.first_uid;
          const isFirstUidExist = isFirstUidExists(
            getlocaldata2,
            DispatchOrderDetail
          );

          if (!isFirstUidExist) {
            const combinedData = olddata.concat(
              DispatchOrderDetail.data.payload
            );

            const flattenedArray = combinedData.flatMap((item) =>
              Array.isArray(item) ? item : [item]
            );

            // modified null value
            const modifiedData = flattenedArray.map((item) => {
              if (item.product_description === null) {
                item.product_description = "-";
              }
              return item;
            });

            localStorage.setItem(
              "SFGOrderDetailTable",
              JSON.stringify(modifiedData)
            );

            const getlocaldata1 = JSON.parse(
              localStorage.getItem("SFGOrderDetailTable")
            );

            setDispatchOrder(...dispatchOrder, getlocaldata1);
          }
          if (isFirstUidExist) {
            setAppState((prevState) => ({ ...prevState, ls_fuid_match: true }));
            setAddStatus(false);
          }

          return DispatchOrderDetail.data.payload.order_id;
        };

        const OrderIdList = () => {
          const getOrderIdDetail = JSON.parse(
            localStorage.getItem("OrderIDList")
          );
          console.log("getOrderIdDetail.......length", getOrderIdDetail.length);

          const OrderidData = [DispatchOrderDetail.data.payload.order_id];

          const combinedData = getOrderIdDetail.concat(OrderidData);

          const RemoveDuplicate = [...new Set(combinedData)];
          console.log("RemoveDuplicate", RemoveDuplicate);

          localStorage.setItem("OrderIDList", JSON.stringify(RemoveDuplicate));

          const GetOrderIdData = JSON.parse(
            localStorage.getItem("OrderIDList")
          );

          setOrderIdButton(GetOrderIdData);

          return GetOrderIdData;
        };

        if (localStorage.getItem("SFGOrderDetailTable")) {
          if (JSON.parse(localStorage.getItem("OrderIDList")).length <= 2) {
            const OrderIds = await OrderIdList();

            function checkData(data) {
              return OrderIds.includes(data);
            }

            const isDataPresent = checkData(
              DispatchOrderDetail.data.payload.order_id
            );

            if (isDataPresent) {
              const DispatchList = await DispatchOrderList();
              RefreshDispatchOrder();
            }
            return true;
          }

          if (JSON.parse(localStorage.getItem("OrderIDList")).length === 3) {
            const GetOrderIdData = JSON.parse(
              localStorage.getItem("OrderIDList")
            );
            setOrderIdButton(GetOrderIdData);

            function checkData(data) {
              return GetOrderIdData.includes(data);
            }

            const isDataPresent = checkData(
              DispatchOrderDetail.data.payload.order_id
            );

            if (!isDataPresent) {
              setAddStatus(false);
              console.log("Order id Not  found");
              setOrderIdPopUp(true);
            }

            if (isDataPresent) {
              const DispatchList = await DispatchOrderList();
              RefreshDispatchOrder();
            }
          }
        } else {
          if (!localStorage.getItem("SFGOrderDetailTable")) {
            localStorage.setItem(
              "SFGOrderDetailTable",
              JSON.stringify([DispatchOrderDetail.data.payload])
            );
          }

          if (!localStorage.getItem("OrderIDList")) {
            localStorage.setItem(
              "OrderIDList",
              JSON.stringify([DispatchOrderDetail.data.payload.order_id])
            );
            RefreshDispatchOrder();
          }
        }
      }
    } catch (e) {
      setUid("");
      if (e.response.status == 400) {
        setAddStatus(false);
        setWrongOrderIdPopUp(true);
        setWrongIdMessage(e.response.data.message);
      }
    }
  };

  const handleAddClick = () => {
    setAddStatus(true);
  };

  const UidHandle = (e) => {
    const Uid_link = e.target.value;
    setUid(Uid_link);
  };
  const handleOutsideClick = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setAddStatus(false);
      setSettingStatus(false);
    }
  };

  useEffect(() => {
    // Attach the click event listener when the popup is open

    if (addStatus) {
      window.addEventListener("click", handleOutsideClick);
    }
    if (settingStatus) {
      window.addEventListener("click", handleOutsideClick);
    }

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener("click", handleOutsideClick);
    };
  }, [addStatus, settingStatus]);

  const handleSettingClick = () => {
    setSettingStatus(true);
  };

  useEffect(() => {
    handleBoxNumber();
  }, []);
  const handleBoxNumber = async () => {
    try {
      const resp = await getSFGBoxNo();
      if (resp.status == 200 || resp.status == 201) {
        setBoxNo(resp.data.payload.box_number);
      }
    } catch (error) {
      setBoxNo();
    }
  };
  const navigate = useNavigate();

  const HandlePrintPreviewStatus = () => {
    // Basic validation for required fields
    if (!sfgLabel) {
      toast.error("Please Enter Box No.");
      return;
    }
    if (!selectedClass) {
      toast.error("Please Select Class");
      return;
    }
    if (!selectSize) {
      toast.error("Please Select Size");
      return;
    }
    if (!selectGlovesType) {
      toast.error("Please Select Gloves Type");
      return;
    }
    if (!selectGlovesLength) {
      toast.error("Please Select Length");
      return;
    }
    if (!selectCuff) {
      toast.error("Please Select Cuff");
      return;
    }
    if (!quantity) {
      toast.error("Please Enter Quantity");
      return;
    }

    // Class-based validation using getValidationData
    const validationRules = getValidationData(selectedClass);

    // If validation rules for the selected class are not found, something is wrong
    if (!validationRules) {
      toast.error("Invalid class selected. Please choose a valid class.");
      return;
    }

    // 1. Validate Quantity
    if (quantity > validationRules.quantity) {
      toast.error(
        `Maximum quantity for this class is ${validationRules.quantity}.`
      );
      return;
    }

    // 2. Validate Gloves Length
    // The image shows both "360 " and "410". The code has "360" and "410"
    // We should normalize the value for comparison.
    const normalizedLength = selectGlovesLength
      .toUpperCase()
      .replace(/\s/g, "");
    const validLengths = validationRules.length.map((len) =>
      len.toUpperCase().replace(/\s/g, "")
    );

    if (!validLengths.includes(normalizedLength)) {
      const validLengthsStr = validationRules.length.join(" or ");
      toast.error(
        `Invalid glove length for class ${selectedClass}. Valid lengths are ${validLengthsStr}.`
      );
      return;
    }

    // If all validations pass, proceed to print preview
    setOpenDialog(false);
    setAddStatus(false);
    setNullDataPopup(false);
    setPrintPreviewStatus(true);
    setPrintHistoryStatus(false);
    setPrintOrderStatus(false);
  };
  const handlePrinter1Change = () => {
    console.log("Click......PrinterChecked1");
    localStorage.setItem("B_Lable_Printer", JSON.stringify({ Printer: 1 }));
    setPrinterChecked1(true);
    setPrinterChecked2(false);
    setPrinterChecked3(false);
  };

  const handlePrinter2Change = () => {
    console.log("Click......PrinterChecked2");
    localStorage.setItem("B_Lable_Printer", JSON.stringify({ Printer: 2 }));
    setPrinterChecked1(false);
    setPrinterChecked2(true);
    setPrinterChecked3(false);
  };

  const handlePrinter3Change = () => {
    console.log("Click......PrinterChecked2");
    localStorage.setItem("B_Lable_Printer", JSON.stringify({ Printer: 2 }));
    setPrinterChecked1(false);
    setPrinterChecked2(false);
    setPrinterChecked3(true);
  };

  const Print_Preview_Box_Lable = () => {
    navigate("/sfg-printer");
    setPrintPreviewStatus(false);
    setPrintHistoryStatus(false);
    setPrintOrderStatus(true);
    setOpenDialog(true);
  };
  const HandlePrintButton = async () => {
    createBoxLabel_api_handle();
  };

  const createBoxLabel_api_handle = async () => {
    // ... (existing code for setting up params)
    const parms = {
      box_no: boxNo,
      printer: printerChecked3
        ? "Printer 3"
        : null ?? printerChecked2
        ? "Printer 2"
        : null ?? printerChecked1
        ? "Printer 1"
        : null,
      class_name: selectedClass,
      size_name: selectSize,
      gloves_type: selectGlovesType,
      length: selectGlovesLength,
      cuff: selectCuff,
      lot_no: lotNumber,
      quantity: quantity,
      sfg_label: sfgLabel,
    };

    try {
      const PrintBox = await createSFGBoxAndHistory(parms);
      setisPrinting(false);
      setisPrintingDone(true);

      if (PrintBox.status === 200) {
        toast.success(PrintBox.data.message);
        RefreshDispatchOrder();
        GetLocalData();
        setPrintdisable(true);
        setboxID(PrintBox.data.payload.sfg_box_id);
        handleBoxNumber();
        // ✅ Add this block to clear the selected fields
        setSelectClass("");
        setSelectSize("");
        setSelectGlovesType("");
        setSelectGlovesLength("");
        setSelectCuff("");
        setLotNumber("");
        setQuantity("");
        setPrintPreviewStatus(false);
        setPrintOrderStatus(true);
        setOpenDialog(true);
      }
    } catch (e) {
      setisPrinting(false);
      setPrintdisable(false);
      toast.error(e.response.data.message);
    }
  };

  useEffect(() => {
    if (
      selectGlovesType &&
      selectedClass &&
      selectSize &&
      selectCuff &&
      selectGlovesLength
    ) {
      handlegetOrderIdParring();
    }
  }, [
    selectGlovesType,
    selectedClass,
    selectSize,
    selectCuff,
    selectGlovesLength,
  ]);

  const handlegetOrderIdParring = async () => {
    const params = {
      gloves_type: selectGlovesType,
      class_name: selectedClass,
      size: selectSize,
      cuff: selectCuff,
      length: selectGlovesLength + "mm",
    };
    try {
      const resp = await getOrderIdParring(params);

      if (resp.status == 200 || resp.status == 201) {
        setOrderItem(resp.data.payload);
        console.log("orderItem successfully");
      }
    } catch (error) {
      console.log("handleSubmit", error);
    }
  };
  return (
    <>
      <ToastContainer />
      {addStatus ? (
        <div>
          <input
            type="text"
            placeholder="Enter value"
            value={Uid}
            onChange={UidHandle}
            style={{ paddingLeft: "20px", position: "absolute", top: "10px" }}
            autoFocus
          />
        </div>
      ) : null}

      <div className="page-wraper">
        {printOrderStatus ? (
          <div className="PackDispatch-header-btn-group1">
            <div className="d-flex justify-content-between align-items-center">
              <div className="page-header mt-2">
                <Link to="/SFG-store" className="page-back-btn">
                  <ArrowBackIcon />
                  <span>SFG Entry</span>
                </Link>
              </div>

              <div className="PackDispatch-header-btn-group ">
                {/* <button
                  className={`PackDispatch-page-header-btn ${
                    printPreviewStatus ? "filled" : ""
                  }`}
                  onClick={() => HandlePrintPreviewStatus()}
                >
                  Print Preview
                </button> */}

                <button
                  className="PackDispatch-page-header-btn"
                  onClick={() => navigate("/sfg-history")}
                >
                  SFG History
                </button>

                {/* <button
                  className="PackDispatch-page-header-btn"
                  onClick={() => handleAddClick()}
                >
                  <AddIcon />
                </button> */}
              </div>
            </div>
            {settingStatus ? (
              <div
                className="PrintOrder-message-box"
                ref={popupRef}
                style={{ right: "6%" }}
              >
                <div className="arrow"></div>

                <span className="Select-Printer">Select Printer</span>
                <br />

                <div className="Printer-container">
                  <span>Printer - 1</span>
                  <Checkbox
                    name="Printer1"
                    className="Printer-checkbox"
                    checked={printerChecked1}
                    onChange={() => handlePrinter1Change()}
                    onClick={() => handlePrinter1Change()}
                  />
                </div>

                <div className="Printer-container">
                  <span>Printer - 2</span>
                  <Checkbox
                    name="Printer2"
                    className="Printer-checkbox"
                    checked={printerChecked2}
                    onChange={() => handlePrinter2Change()}
                    onClick={() => handlePrinter2Change()}
                  />
                </div>
                <div className="Printer-container">
                  <span>Printer - 3</span>
                  <Checkbox
                    name="Printer3"
                    className="Printer-checkbox"
                    checked={printerChecked3}
                    onChange={() => handlePrinter3Change()}
                    onClick={() => handlePrinter3Change()}
                  />
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
        {printPreviewStatus ? (
          <>
            <div className="Print-Preview-header" style={{ marginTop: "20px" }}>
              <div>
                <div
                  className="page-back-btn"
                  onClick={() => Print_Preview_Box_Lable()}
                  style={{ cursor: "pointer" }}
                >
                  <ArrowBackIcon />
                  <span>SFG Store Box Label Printing</span>
                </div>
              </div>

              <div className="Preview-PrintHistory-button">
                <div
                  className="PackDispatch-header-btn-data"
                  style={{
                    background: "#e5eaf6",
                    padding: "9px 9px",
                    color: "#405a84",
                  }}
                >
                  <b style={{ margin: "3px" }}>Box No</b>
                  <b style={{ margin: "3px" }}>:</b>
                  {boxNo}
                </div>
                <button
                  className={`PackDispatch-page-header-btn  ${
                    printHistoryStatus ? "filled" : ""
                  }`}
                  onClick={() => HandlePrintButton()}
                >
                  Print
                </button>
                <button
                  className="PackDispatch-SettingsIcon-btn "
                  onClick={() => {
                    handleSettingClick();
                  }}
                >
                  <SettingsIcon className="SettingsIcon" />
                </button>
              </div>
              {settingStatus ? (
                <div
                  className="PrintOrder-message-box"
                  ref={popupRef}
                  style={{ right: "3%", top: "19%" }}
                >
                  <div className="arrow"></div>

                  <span className="Select-Printer">Select Printer</span>
                  <br />

                  <div className="Printer-container">
                    <span>Printer - 1</span>
                    <Checkbox
                      name="Printer1"
                      className="Printer-checkbox"
                      checked={printerChecked1}
                      onChange={() => handlePrinter1Change()}
                      onClick={() => handlePrinter1Change()}
                    />
                  </div>

                  <div className="Printer-container">
                    <span>Printer - 2</span>
                    <Checkbox
                      name="Printer2"
                      className="Printer-checkbox"
                      checked={printerChecked2}
                      onChange={() => handlePrinter2Change()}
                      onClick={() => handlePrinter2Change()}
                    />
                  </div>
                  <div className="Printer-container">
                    <span>Printer - 3</span>
                    <Checkbox
                      name="Printer3"
                      className="Printer-checkbox"
                      checked={printerChecked3}
                      onChange={() => handlePrinter3Change()}
                      onClick={() => handlePrinter3Change()}
                    />
                  </div>
                </div>
              ) : null}
            </div>

            <div className="Print-Preview-main-container">
              <div
                style={{
                  padding: "100px 45px 36px 10px",
                  display: "flex",
                  background: "#ffffff",
                  justifyContent: "center",
                }}
              >
                <div className="PrintPreview-main-left">
                  <QRCode
                    value={"https://www.raychemrpg.com"}
                    className="DemoOR"
                    alt="DemoOR"
                  />

                  <br />
                  <div className="Scanforme">
                    <span>Scan for me material details in box</span>
                  </div>

                  <img
                    src={images.RaychemRPGLogo}
                    className="RaychemRPGLogo"
                    alt="RaychemRPGLogo"
                  />
                </div>

                <div className="PrintPreview-main-right">
                  <div className="PrintPreview-main-right-row-img">
                    <img src={images.Kamfet} className="Kamfet" alt="Kamfet" />
                    <img
                      src={images.ElectricalGloves}
                      className="ElectricalGloves"
                      alt="ElectricalGloves"
                    />
                    <img
                      src={images.ExaminationModule}
                      className="ExaminationModule"
                      alt="ExaminationModule"
                    />
                  </div>

                  <table
                    style={{
                      width: "100%",
                      border: "1px solid #ccc", // ✅ Full border
                      borderRadius: "4px",
                      padding: "8px",
                      color: selectedClass ? "#000" : "gray",
                    }}
                    className="PrintPreview-main-right-table1"
                  >
                    <tr>
                      <th
                        style={{ width: "30%" }}
                        className="Customer-Name PrintPreview-main-right-table1-th"
                      >
                        PCN Number:
                      </th>
                      <td className="Customer-Name PrintPreview-main-right-table1-td">
                        {orderItem}
                      </td>
                    </tr>
                  </table>

                  <table
                    style={{
                      width: "100%",
                      border: "1px solid #ccc", // ✅ Full border
                      borderRadius: "4px",
                      padding: "8px",
                      color: selectedClass ? "#000" : "gray",
                    }}
                    className="PrintPreview-main-right-table2"
                  >
                    <tr className="PrintPreview-main-right-table2-tr">
                      <th
                        style={{ width: "80%" }}
                        className="PrintPreview-main-right-table2-th "
                      >
                        Product Description :
                      </th>
                      <th className="PrintPreview-main-right-table1-td ">
                        Qty :
                      </th>
                    </tr>

                    <tr className="PrintPreview-main-right-table2-tr">
                      <td className="tabledata">
                        <span>
                          {`RUBBER ${selectGlovesType.toUpperCase()} GLOVES, CLASS ${selectedClass}, ${selectGlovesLength}, SIZE ${selectSize}, ${
                            selectCuff == "S.C."
                              ? "STRAIGHT CUFF"
                              : selectCuff == "R.E."
                              ? "ROLLED EDGE"
                              : ""
                          }`}
                        </span>
                      </td>

                      <td className="PrintPreview-main-right-table1-td tabledata">
                        <b>{quantity}</b>
                      </td>
                    </tr>
                  </table>
                  <div style={{ paddingTop: "30px" }}>
                    <h1 style={{ fontSize: "77px", fontWeight: 400 }}>
                      Box Number : <b>{sfgLabel}</b>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : null}
        {printOrderStatus && openDialog && (
          <Box sx={modalStyle}>
            {/* Modal Body with Form */}
            <Box sx={{ p: 2 }}>
              <Stack component="form" onSubmit={handleSubmit}>
                {/* Box No. */}
                <div>
                  <label style={labelStyle}>Label No.</label>
                  <input
                    type="text"
                    value={boxNo ?? ""}
                    disabled
                    style={inputStyle}
                  />
                </div>
                <div className="mt-1">
                  <label style={labelStyle}>Box No.</label>
                  <input
                    type="text"
                    value={sfgLabel ?? ""}
                    maxLength={4} // ⬅️ Restricts typing to 4 characters
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 4) {
                        setSfgLabel(value);
                      }
                    }}
                    style={inputStyle}
                  />
                </div>

                {/* Class Dropdown */}
                <div style={{ marginTop: "7px" }}>
                  <label style={labelStyle}>Class</label>
                  <select
                    value={selectedClass}
                    onChange={(e) => setSelectClass(e.target.value)}
                    style={{
                      ...inputStyle,
                      color: selectedClass ? "#000" : "gray",
                    }}
                  >
                    <option value="">Select Class</option>
                    {classes && classes.length > 0 ? (
                      classes.map((event) => (
                        <option key={event.class_name} value={event.class_name}>
                          {event.class_name}
                        </option>
                      ))
                    ) : (
                      <option disabled>No Data Found</option>
                    )}
                  </select>
                </div>

                {/* Size Dropdown */}
                <div style={{ marginTop: "7px" }}>
                  <label style={labelStyle}>Size</label>
                  <select
                    value={selectSize}
                    onChange={(e) => setSelectSize(e.target.value)}
                    style={{
                      ...inputStyle,
                      color: selectSize ? "#000" : "gray",
                    }}
                  >
                    <option value="">Select Size</option>
                    {size && size.length > 0 ? (
                      size.map((event) => (
                        <option key={event.size_name} value={event.size_name}>
                          {event.size_name}
                        </option>
                      ))
                    ) : (
                      <option disabled>No Data Found</option>
                    )}
                  </select>
                </div>

                {/* Gloves Type Dropdown */}
                <div style={{ marginTop: "7px" }}>
                  <label style={labelStyle}>Gloves Type</label>
                  <select
                    value={selectGlovesType}
                    onChange={(e) => setSelectGlovesType(e.target.value)}
                    style={{
                      ...inputStyle,
                      color: selectGlovesType ? "#000" : "gray",
                    }}
                  >
                    <option value="">Select Gloves Type</option>
                    <option value="Insulating">Insulating</option>
                    <option value="Composite">Composite</option>
                  </select>
                </div>

                {/* Length Dropdown */}
                <div style={{ marginTop: "7px" }}>
                  <label style={labelStyle}>Length</label>
                  <select
                    value={selectGlovesLength}
                    onChange={(e) => setSelectGlovesLength(e.target.value)}
                    style={{
                      ...inputStyle,
                      color: selectGlovesLength ? "#000" : "gray",
                    }}
                  >
                    <option value="">Select Length</option>
                    {GlovesLength && GlovesLength.length > 0 ? (
                      GlovesLength.map((element) => (
                        <option key={element.length} value={element.length}>
                          {element.length}
                        </option>
                      ))
                    ) : (
                      <option disabled>No Data Found</option>
                    )}
                  </select>
                </div>

                {/* Cuff Dropdown */}
                <div style={{ marginTop: "7px" }}>
                  <label style={labelStyle}>Cuff</label>
                  <select
                    value={selectCuff}
                    onChange={(e) => setSelectCuff(e.target.value)}
                    style={{
                      ...inputStyle,
                      color: selectCuff ? "#000" : "gray",
                    }}
                  >
                    <option value="">Select Cuff</option>
                    {cuff && cuff.length > 0 ? (
                      cuff.map((element) => (
                        <option
                          key={element.cuff_name}
                          value={element.cuff_name}
                        >
                          {element.cuff_name}
                        </option>
                      ))
                    ) : (
                      <option disabled>No Data Found</option>
                    )}
                  </select>
                </div>

                {/* Lot No. */}
                <div style={{ marginTop: "7px" }}>
                  <label style={labelStyle}>Lot No.</label>
                  <input
                    type="text"
                    value={lotNumber ?? ""}
                    disabled
                    style={inputStyle}
                  />
                </div>

                {/* Quantity */}
                <div style={{ marginTop: "7px" }}>
                  <label style={labelStyle}>Quantity</label>
                  <input
                    placeholder="Type-in required quantity"
                    value={quantity}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        // ✅ only digits allowed
                        setQuantity(value);
                      }
                    }}
                    style={inputStyle}
                  />
                </div>

                {/* Packed By */}
                <div style={{ marginTop: "7px" }}>
                  <label style={labelStyle}>Packed By</label>
                  <input
                    type="text"
                    value={login.userName ?? ""}
                    disabled
                    style={inputStyle}
                  />
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  style={{
                    padding: "10px 20px",
                    marginTop: "16px",
                    backgroundColor: "#192d6e",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={HandlePrintPreviewStatus}
                >
                  Print Preview
                </button>
              </Stack>
            </Box>
          </Box>
        )}
      </div>
      {addStatus ? (
        <div className="Phone-image" ref={popupRef}>
          <img
            src={require("../../assets/images/phone.png")}
            alt="Description of the SVG"
            className="Phone-img"
          />
        </div>
      ) : null}

      {appState.ls_fuid_match ? (
        <>
          <div className="sendingdataaaa1">
            <Card className="pairingcard-Approved">
              <CardContent className="p-0 pairing-status">
                <h4>This Uid Already Scaned !</h4>
              </CardContent>
              <Button
                className="pairingcard-btn"
                title="Close"
                onClick={() => {
                  setAppState({ ...appState, ls_fuid_match: false });
                }}
              />
            </Card>
          </div>
        </>
      ) : null}

      {nullDataPopup ? (
        <>
          <div className="sendingdataaaa1">
            <Card className="pairingcard-Approved">
              <CardContent className="p-0 pairing-status">
                <h4>No Data Found ....Please Scan Gloves</h4>
              </CardContent>
              <Button
                className="pairingcard-btn"
                title="Close"
                onClick={() => {
                  setNullDataPopup(false);
                }}
              />
            </Card>
          </div>
        </>
      ) : null}

      {orderIdPopUp ? (
        <>
          <div className="sendingdataaaa1">
            <Card className="pairingcard-Approved">
              <CardContent className="p-0 pairing-status">
                <h4>{"You Can Not Scan More Then 3 Order Id Gloves Bag."}</h4>
              </CardContent>
              <Button
                className="pairingcard-btn"
                title="Ok"
                onClick={() => {
                  ClosePopUp();
                  setAddStatus(true);
                }}
              />
            </Card>
          </div>
        </>
      ) : null}
      {wrongOrderIdPopUp ? (
        <>
          <div className="sendingdataaaa1">
            <Card className="pairingcard-Approved">
              <CardContent className="p-0 pairing-status">
                <h4>
                  {wrongIdMessage ??
                    "UID pair does not belong to the provided customer"}
                </h4>
              </CardContent>
              <Button
                className="pairingcard-btn"
                title="Ok"
                onClick={() => {
                  ClosePopUp();
                  setAddStatus(true);
                }}
              />
            </Card>
          </div>
        </>
      ) : null}

      {isWrongClass ? (
        <>
          <div className="sendingdataaaa1">
            <Card className="pairingcard-Approved">
              <CardContent className="p-0 pairing-status">
                <h4>All gloves must be of the same class!</h4>
              </CardContent>
              <Button
                className="pairingcard-btn"
                title="Ok"
                onClick={() => {
                  setIsWrongClass(false);
                  setAddStatus(true);
                }}
              />
            </Card>
          </div>
        </>
      ) : null}

      {isWrongLength ? (
        <>
          <div className="sendingdataaaa1">
            <Card className="pairingcard-Approved">
              <CardContent className="p-0 pairing-status">
                <h4>Invalid glove length for this class!</h4>
              </CardContent>
              <Button
                className="pairingcard-btn"
                title="Ok"
                onClick={() => {
                  setIsWrongLength(false);
                  setAddStatus(true);
                }}
              />
            </Card>
          </div>
        </>
      ) : null}

      {isOverQuantity ? (
        <>
          <div className="sendingdataaaa1">
            <Card className="pairingcard-Approved">
              <CardContent className="p-0 pairing-status">
                <h4>Maximum quantity for this class has been reached!</h4>
              </CardContent>
              <Button
                className="pairingcard-btn"
                title="Ok"
                onClick={() => {
                  setIsOverQuantity(false);
                  setAddStatus(true);
                }}
              />
            </Card>
          </div>
        </>
      ) : null}

      {isPrinting ? (
        <>
          <div className="sendingdatasimple-pop-up">
            <Card className="pairingcard-Approved-simple-pop-up">
              <CardContent className="p-0 pairing-status">
                <h4>{"Printing....."}</h4>
              </CardContent>
            </Card>
          </div>
        </>
      ) : null}
      {isPrintingDone ? (
        <>
          <div className="sendingdataaaa1">
            <Card className="pairingcard-Approved">
              <CardContent className="p-0 pairing-status">
                <h4>Printed</h4>
              </CardContent>
              <Button
                className="pairingcard-btn"
                title="Yes"
                onClick={() => handleRemoveStorage()}
              />
              <Button
                className="pairingcard-btn"
                title="No"
                onClick={() => {
                  NoPrintHandle();
                }}
              />
            </Card>
          </div>
        </>
      ) : null}
      {printAgainStatus ? (
        <>
          <div className="sendingdataaaa1">
            <Card className="pairingcard-Approved">
              <CardContent className="p-0 pairing-status">
                <h4>Print Again?</h4>
              </CardContent>
              <Button
                className="pairingcard-btn"
                title="Yes"
                onClick={() => handlePrintagain()}
              />
              <Button
                className="pairingcard-btn"
                title="No"
                onClick={() => {
                  window.location.reload();
                }}
              />
            </Card>
          </div>
        </>
      ) : null}

      {noDataStatus ? (
        <>
          <div className="sendingdataaaa1">
            <Card className="pairingcard-Approved">
              <CardContent className="p-0 pairing-status">
                <h4>Data Not Found !</h4>
              </CardContent>
              <Button
                className="pairingcard-btn"
                title="Close"
                onClick={() => {
                  setNoDataStatus(false);
                }}
              />
            </Card>
          </div>
        </>
      ) : null}

      {/* <SFGBoxHistory /> */}
    </>
  );
};
export default SFGPrinter;
